import { queryCurrencyExchangeRateAndSymbol } from '@/api/currency/currency'

export const getCurrencies = async () => {
    const cacheStr = localStorage.getItem("cachedCurrencies")
    let data = null;
    if (cacheStr) {
        const obj = JSON.parse(cacheStr);
        if (Date.now() - obj?.timestamp <= 1 * 60 * 60 * 1000) {
            data = obj.currencies
        }
    }
    if (!data) {
        let res = await queryCurrencyExchangeRateAndSymbol();
        if (res && res.code === "0") {
            data = res.data
            localStorage.setItem("cachedCurrencies", JSON.stringify({ "timestamp": Date.now(), "currencies": data }))

        }
    }
    return data || []
}

export const getExchangeAmount = async (currency, targetCurrency, amount) => {
    if (!currency) {
        return amount
    }
    let changeCurrency = targetCurrency || "CNY"
    let currencies = await getCurrencies()
    let exchange = null;
    for (let item of currencies) {
        if (currency === item.currencyCode && changeCurrency === item.targetCurrency) {
            exchange = item
            break
        }
    }

    if (!exchange) {
        return currency + " " + amount
    }
    let changeSymbol = await getCurrencySymbol(changeCurrency)
    return "约合" + exchange.targetCurrency + " " + changeSymbol + " " + (amount * (exchange.exchangeRate || 1)).toFixed(2)
}


export const getCurrencySymbol = async (currency) => {
    let exchange = null;
    let currencies = await getCurrencies()
    for (let item of currencies) {
        if (currency === item.currencyCode) {
            exchange = item
            break
        }
    }
    if (!exchange) {
        return currency
    }
    return exchange.symbol
}